/**
 * Keyboard focus around the HUD's overlays (08 §2.8-2.9): an overlay that takes focus remembers what had it and
 * hands it back when it closes, so a keyboard player lands where he was.
 */

export class FocusKeeper {
  private before: HTMLElement | null = null;

  constructor(private readonly root: HTMLElement) {}

  /** An overlay is taking focus: remember what had it, unless that was inside the HUD itself. */
  remember(): void {
    const active = document.activeElement;
    this.before = active instanceof HTMLElement && !this.root.contains(active) ? active : null;
  }

  /** Hand keyboard focus back to whatever had it before an overlay took it. */
  release(): void {
    const active = document.activeElement;
    if (active instanceof HTMLElement && this.root.contains(active)) active.blur();
    const before = this.before;
    this.before = null;
    if (before !== null && before.isConnected && before !== document.body) before.focus({ preventScroll: true });
  }
}
